import React from 'react';

import { TableCell, TableRow, Typography } from '@mui/material';

interface Props {
  colSpan: number;
  message: string;
}

export default function CaseEmptyRow({ colSpan, message }: Props) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Typography color="text.secondary">{message}</Typography>
      </TableCell>
    </TableRow>
  );
}
